var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('eqify-page',{attrs:{"no-title-text":"","actions":[
      {name:_vm.$t('courses.create.label'), icon:'book',to:'/courses/create',variant:'primary', multiFederation:true, checkPermission: _vm.canCreate}
  ]}},[_c('calendar-component',{attrs:{"title":"Cursussen","search-callback":_vm.searchCallback,"save-search-data":true,"save-storage-prefix":"courses"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }